import { SET_MAP_GEOHASHES, SET_MAP_CENTER, SET_MAP_ZOOM } from './map.types';
import { AnyAction, Reducer } from 'redux';
import { MapState } from 'models/redux/map.state';
import { getEnvCenter } from 'environments/env';

const initialState: MapState = {
  mapGeohashes: [],
  mapBounds: undefined,
  zoom: 15,
  center: getEnvCenter(), //Initial center to Colombia
  centerChange: false,
  refresh: 1,
  isOnRefresh: false,
};

const reducer: Reducer<MapState> = (
  state: MapState = initialState,
  action: AnyAction = { type: undefined },
) => {
  switch (action.type) {
    case SET_MAP_GEOHASHES:
    case SET_MAP_CENTER:
    case SET_MAP_ZOOM:
      return { ...state, ...action.payload };

    default:
      return state;
  }
};

export default reducer;
